import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Relative dependencies.
import { SCWAccessDiceComponent } from './access-dice.component';

@NgModule({
  imports: [ CommonModule ],
  exports: [ SCWAccessDiceComponent ],
  declarations: [ SCWAccessDiceComponent ],
  providers: [],
})
export class SCWAccessDiceModule {
  
}